import React, { useEffect, useState } from 'react';
import { client } from 'cccisd-apollo';
import {
    SecureMessagingSingleConversation,
    SecureMessagingMultipleConversations,
} from 'cccisd-laravel-secure-messaging';
import query from './MessagesWithSupervisor.graphql';
import style from './style.css';

const Fortress = window.cccisd.fortress;

function SecureMessagingProvider() {
    const [supervisor, setSupervisor] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchSupervisor() {
            const response = await client.query({
                query,
                variables: {
                    pawnId: Fortress.user.acting.id,
                },
                fetchPolicy: 'network-only',
            });

            const supervisors = [];
            const supervisorData = response.data.roles.instructor.parentRoles.supervisor;

            if (supervisorData) {
                const { pawn, user } = supervisorData;
                const newParticipant = {
                    id: pawn.pawnId,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    username: user.username,
                };
                supervisors.push(newParticipant);
            }

            setSupervisor(supervisors);
            setLoading(false);
        }

        fetchSupervisor();
    }, []);

    if (loading) {
        return null;
    }

    const user = Fortress.user;
    const primaryParticipant = {
        id: user.pawnId,
        firstName: user.firstName,
        lastName: user.lastName,
        username: user.username,
    };

    if (!supervisor || supervisor.id === null) {
        return (
            <div className="alert alert-warning">
                <p>
                    You do not have a current supervisor. Once you are linked to a supervisor, you will be able to
                    message your supervisor here.
                </p>
            </div>
        );
    }

    return (
        <div className={style.messageBox}>
            {supervisor.length <= 1 ? (
                <SecureMessagingSingleConversation
                    primaryParticipant={primaryParticipant}
                    anotherParticipant={supervisor[0]}
                />
            ) : (
                <SecureMessagingMultipleConversations
                    primaryParticipant={primaryParticipant}
                    anotherParticipants={supervisor}
                />
            )}
        </div>
    );
}

export default SecureMessagingProvider;
